import { Add, AutoMode, FilterList, Search } from "@mui/icons-material";
import {
  Box,
  Checkbox,
  Collapse,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
} from "@mui/material";
import "./NewOrders.css";
import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { useNavigate, useLocation } from "react-router";
import NotFound from "./SharedModule/NotFound";
import { Modal } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import {
  ChevronDown,
  ChevronUp,
  Eye,
  EyeOff,
  MapPin,
  PenSquare,
  Truck,
} from "lucide-react";
import DatePickerDMY from "./DatePickerDMY";
import { formatNumber } from "../hooks/formatNumber";
import { database } from "../firebase";
import {
  ref,
  onChildAdded,
  limitToLast,
  query,
  onChildChanged,
} from "firebase/database";
import MarkAllAsRead from "./SharedModule/MarkAllAsRead";

export default function Ordres() {
  const { user } = useSelector((state) => state.auth);

  console.log(user);

  const token = user?.token;

  const newBaseUrl = "https://estbn.com/EstbnNew/public";

  const headers = {
    Authorization: "Bearer " + token,
  };

  const navigate = useNavigate();

  const location = useLocation();

  const searchTimeout = useRef(null);

  // ********************* tabs ***************************

  const [total, setTotal] = useState(null);

  const [statuses, setStatuses] = useState([]);

  const getStatuses = async () => {
    try {
      let response = await axios.get(
        `${newBaseUrl}/api/portal/order-statuses`,
        {
          headers,
        },
      );
      console.log(response.data.data);
      setTotal(response.data.data.statistics.total_orders);
      setStatuses(response.data.data.orderStatuses);
    } catch (error) {
      console.log(error);
    }
  };

 const [selectedTab, setSelectedTab] = useState(location.state?.status || "");

  const selectedTabRef = useRef(selectedTab);

  useEffect(() => {
    selectedTabRef.current = selectedTab;
  }, [selectedTab]);

  // ********************** orders data *************************

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const [searchQuery, setSearchQuery] = useState("");

  const [filterDate, setFilterDate] = useState("");

  const [orders, setOrders] = useState([]);

  const getOrders = async () => {
    try {
      const params = {
        page: page + 1,
        per_page: rowsPerPage,
      };
      if (filterDate) {
        params.reservation_date = filterDate;
      }
      if (selectedTab && selectedTab !== "all") {
        params.status = selectedTab;
      }
      if (searchQuery.trim()) {
        params.search = searchQuery.trim();
      }
      const response = await axios.get(
        `https://estbn.com/EstbnNew/public/api/portal/orders`,
        { headers, params },
      );
      const data = response.data.data;

      setOrders(data.orders || []);
      setTotalCount(data.pagination.total);
      setRowsPerPage(data.pagination.per_page);
      applyStatusChangesFromStorage(data.orders || []);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setPage(0);
      getOrders();
    }, 400);
    return () => clearTimeout(searchTimeout.current);
  }, [searchQuery]);

  const handleToggleRead = async (orderId) => {
    try {
      await axios.get(`${newBaseUrl}/api/portal/toggle_read/${orderId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setOrders((prev) =>
        prev.map((o) =>
          o.id === orderId
            ? { ...o, is_read: o.is_read == "0" ? "1" : "0" }
            : o,
        ),
      );
      clearUpdatedStatus(orderId);
    } catch (err) {
      console.error("Toggle read failed", err);
    }
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleSelectRow = (id) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((r) => r !== id) : [...prev, id],
    );
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const allIds = orders.map((row) => row.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };

  // collabse row

  const [openRowId, setOpenRowId] = useState(null);

  const handleToggleRow = (id) => {
    setOpenRowId((prev) => (prev === id ? null : id));
  };

  // paginations functions

  const [page, setPage] = useState(0);

  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [totalCount, setTotalCount] = useState(0);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    console.log(newPage);
  };

  // ******************** arramge **********************

  const [showAutoArrangeModal, setShowAutoArrangeModal] = useState(false);

  const [autoArrangeLoading, setAutoArrangeLoading] = useState(false);

  const [arrangedDone, setArrangedDone] = useState(false);

  const confirmedCount =
    (statuses.find((s) => s.name === "scheduled")?.order_count || 0) +
    (statuses.find((s) => s.name === "rescheduled")?.order_count || 0);

  const assignedCount =
    statuses.find((s) => s.name === "assigned")?.order_count || 0;

  const isConfirmedTab =
    selectedTab === "scheduled" || selectedTab === "rescheduled";

  const isAssignedTab = selectedTab === "assigned";

  const canAutoArrange = isConfirmedTab && confirmedCount > 0;

  const canViewAssigned = isAssignedTab && assignedCount > 0;

  const isButtonDisabled =
    autoArrangeLoading ||
    (!canAutoArrange && !canViewAssigned && !arrangedDone);

  const handleAutoArrangeClick = () => {
    if (confirmedCount > 0) {
      setShowAutoArrangeModal(true);
    }
  };

  const handleConfirmAutoArrange = () => {
    setShowAutoArrangeModal(false);
    setAutoArrangeLoading(true);

    setTimeout(() => {
      setAutoArrangeLoading(false);
      setArrangedDone(true);
      navigate("/Map", { state: { status: selectedTab } });
    }, 3000);
  };

  // ******************** effects **********************

  useEffect(() => {
    getStatuses();
  }, []);

  useEffect(() => {
    getOrders();
  }, [page, rowsPerPage, filterDate, selectedTab]);

  useEffect(() => {
    setPage(0);
  }, [searchQuery]);

  useEffect(() => {
    if (location.state?.status) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  // ****************** firbase ************************

  const [newOrderIds, setNewOrderIds] = useState(new Set());
  const [updatedStatusIds, setUpdatedStatusIds] = useState(() => {
    const stored = sessionStorage.getItem("orders_updatedStatusIds");
    return stored ? new Set(JSON.parse(stored)) : new Set();
  });

  const [statusTransitions, setStatusTransitions] = useState(() => {
    const stored = sessionStorage.getItem("orders_statusTransitions");
    return stored ? JSON.parse(stored) : {};
  });

  const saveLastKnownStatus = (order) => {
    const stored = sessionStorage.getItem("orders_lastKnownStatus");
    const map = stored ? JSON.parse(stored) : {};
    map[order.id] = {
      label: order.order_status?.label,
      image_url: order.order_status?.image_url,
    };
    sessionStorage.setItem("orders_lastKnownStatus", JSON.stringify(map));
  };

  const applyStatusChangesFromStorage = (fetchedOrders) => {
    const stored = sessionStorage.getItem("orders_lastKnownStatus");
    if (!stored) return;

    const map = JSON.parse(stored);
    let mapChanged = false;

    const newTransitions = {};
    const newUpdatedIds = [];

    fetchedOrders.forEach((order) => {
      const prevStatus = map[order.id];
      if (prevStatus && prevStatus.label !== order.order_status?.label) {
        newTransitions[order.id] = {
          oldName: prevStatus.label || "-",
          oldIcon: prevStatus.image_url,
        };
        newUpdatedIds.push(order.id);
      }
      if (prevStatus) {
        delete map[order.id]; 
        mapChanged = true;
      }
    });

    if (newUpdatedIds.length) {
      setStatusTransitions((prev) => {
        const next = { ...prev, ...newTransitions };
        sessionStorage.setItem(
          "orders_statusTransitions",
          JSON.stringify(next),
        );
        return next;
      });
      setUpdatedStatusIds((prev) => {
        const next = new Set([...prev, ...newUpdatedIds]);
        sessionStorage.setItem(
          "orders_updatedStatusIds",
          JSON.stringify([...next]),
        );
        return next;
      });
    }

    if (mapChanged) {
      sessionStorage.setItem("orders_lastKnownStatus", JSON.stringify(map));
    }
  };

  const clearNewOrder = (id) => {
    setNewOrderIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      return next;
    });
  };

  useEffect(() => {
    if (!token) return;
    const pageOpenTime = Date.now();
    const liveOrdersRef = query(ref(database, "orders"), limitToLast(5));
    const unsubscribe = onChildAdded(liveOrdersRef, (snapshot) => {
      const data = snapshot.val();
      const recordTime = new Date(data.created_at).getTime();
      if (recordTime < pageOpenTime) {
        console.log("⏭️ Old record, skipping:", data);
        return;
      }
      console.log("🆕 New order id:", data.id);
      setTimeout(() => {
        axios
          .get(`${newBaseUrl}/api/portal/orders`, {
            headers,
            params: { id: data.id },
          })
          .then((res) => {
            console.log("📦 New order data:", res.data);
            const newOrder = res.data.data.orders?.[0];
            if (!newOrder) return;

            const currentTab = selectedTabRef.current;
            const newOrderStatusName = newOrder.order_status?.name; 

            const matchesCurrentTab =
              currentTab === "all" ||
              currentTab === "" ||
              currentTab === newOrderStatusName;

            if (matchesCurrentTab) {
              setOrders((prev) => {
                if (prev.find((o) => o.id === newOrder.id)) return prev;
                return [newOrder, ...prev];
              });
              setTotalCount((prev) => prev + 1);
              setNewOrderIds((prev) => new Set([...prev, newOrder.id]));
            }
            getStatuses();
          })
          .catch(console.error);
      }, 8000);
    });
    return () => unsubscribe();
  }, [token]);

  const pageOpenTime = useRef(Date.now());

  const clearUpdatedStatus = (id) => {
    setUpdatedStatusIds((prev) => {
      const next = new Set(prev);
      next.delete(id);
      sessionStorage.setItem(
        "orders_updatedStatusIds",
        JSON.stringify([...next]),
      );
      return next;
    });
    setStatusTransitions((prev) => {
      const next = { ...prev };
      delete next[id];
      sessionStorage.setItem("orders_statusTransitions", JSON.stringify(next));
      return next;
    });
  };

  const statusesRef = useRef(statuses);

  useEffect(() => {
    statusesRef.current = statuses;
  }, [statuses]);

  useEffect(() => {
    if (!token) return;

    const statusRef = ref(database, "status_updated/orders");

    const handleStatusUpdate = (snapshot) => {
      const orderId = Number(snapshot.key);
      const data = snapshot.val();
      if (!data?.updated_at) return;

      const recordTime = new Date(data.updated_at).getTime();
      if (recordTime < pageOpenTime.current) {
        console.log("⏭️ OLD - skip", orderId);
        return;
      }

      const newStatus = statusesRef.current.find((s) => s.id == data.status_id);
      if (!newStatus) return;

      console.log("🔥 NEW STATUS:", orderId, newStatus);
      setOrders((prev) => {
        const current = prev.find((o) => o.id === orderId);
        if (current) {
          setStatusTransitions((t) => {
            const next = {
              ...t,
              [orderId]: {
                oldName: current.order_status?.label || "-",
                oldIcon: current.order_status?.image_url,
              },
            };
            sessionStorage.setItem(
              "orders_statusTransitions",
              JSON.stringify(next),
            );
            return next;
          });
        }
        return prev.map((order) =>
          order.id == orderId
            ? {
                ...order,
                order_status: {
                  id: newStatus.id,
                  label: newStatus.label,
                  color: newStatus.color,
                  image_url: newStatus.image_url,
                },
              }
            : order,
        );
      });

      setUpdatedStatusIds((prev) => {
        const next = new Set([...prev, orderId]);
        sessionStorage.setItem(
          "orders_updatedStatusIds",
          JSON.stringify([...next]),
        );
        return next;
      });
    };

    const unsub1 = onChildAdded(statusRef, handleStatusUpdate);
    const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

    return () => {
      unsub1();
      unsub2();
    };
  }, [token]);

  // useEffect(() => {
  //   if (!token || !statuses.length) return;

  //   const statusRef = ref(database, "status_updated/orders");

  //   const handleStatusUpdate = (snapshot) => {
  //     const orderId = Number(snapshot.key);
  //     const data = snapshot.val();
  //     if (!data?.updated_at) return;
  //     const recordTime = new Date(data.updated_at).getTime();
  //     if (recordTime < pageOpenTime.current) {
  //       console.log("⏭️ OLD - skip", orderId);
  //       return;
  //     }
  //     const newStatus = statuses.find((s) => s.id == data.status_id);
  //     if (!newStatus) return;
  //     console.log("🔥 NEW STATUS:", orderId, newStatus);
  //     setOrders((prev) => {
  //       const current = prev.find((o) => o.id === orderId);
  //       if (current) {
  //         setStatusTransitions((t) => {
  //           const next = {
  //             ...t,
  //             [orderId]: {
  //               oldName: current.order_status?.label || "-",
  //               oldIcon: current.order_status?.image_url,
  //             },
  //           };
  //           sessionStorage.setItem(
  //             "orders_statusTransitions",
  //             JSON.stringify(next),
  //           );
  //           return next;
  //         });
  //       }
  //       return prev.map((order) =>
  //         order.id == orderId
  //           ? {
  //               ...order,
  //               order_status: {
  //                 id: newStatus.id,
  //                 label: newStatus.label,
  //                 color: newStatus.color,
  //                 image_url: newStatus.image_url,
  //               },
  //             }
  //           : order,
  //       );
  //     });

  //     setUpdatedStatusIds((prev) => {
  //       const next = new Set([...prev, orderId]);
  //       sessionStorage.setItem(
  //         "orders_updatedStatusIds",
  //         JSON.stringify([...next]),
  //       );
  //       return next;
  //     });
  //   };

  //   const unsub1 = onChildAdded(statusRef, handleStatusUpdate);
  //   const unsub2 = onChildChanged(statusRef, handleStatusUpdate);

  //   return () => {
  //     unsub1();
  //     unsub2();
  //   };
  // }, [token, statuses]);

  // ****************** firbase ************************

  return (
    <div className="m-4">
      {/* arrange modal */}
      <Modal
        show={showAutoArrangeModal}
        onHide={() => setShowAutoArrangeModal(false)}
        centered
      >
        <div className="text-center py-4 px-3">
          <h4>Confirm Auto Arrange to Vehicles</h4>
        </div>

        <div className="text-center px-4">
          <p style={{ color: "#535353" }}>
            Do you want to proceed with automatically assigning orders to
            available vehicles? After confirming, assignments will be dispatched
            to drivers using current settings.
          </p>
        </div>

        <div className="d-flex justify-content-center gap-3 py-4">
          <button
            className="btn btn-light px-4"
            onClick={() => setShowAutoArrangeModal(false)}
          >
            Cancel
          </button>
          <button
            className="btn btn-dark px-4"
            onClick={handleConfirmAutoArrange}
          >
            Confirm
          </button>
        </div>
      </Modal>
      {/* orders header */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center gap-2 mb-3">
        <h5 className="fw-bold mb-0">Orders</h5>
        <div className="d-flex">
          <MarkAllAsRead page="orders" onSuccess={() => getOrders()} />

          {user?.operator.roles[0].name === "supervisor" ? (
            <button
              disabled
              //   onClick={handleShow}
              className="btn btn-outline-secondary d-flex align-items-center mx-2"
            >
              <Truck size={18} className="me-2" /> Assign to a vehicle
            </button>
          ) : (
            ""
          )}
          <button
            disabled
            //   onClick={handleShow}
            className="btn btn-outline-secondary d-flex align-items-center"
          >
            <MapPin size={18} className="me-2" /> Location on map
          </button>
        </div>
      </div>
      {/* search section */}
      <div className="d-flex justify-content-between align-items-center w-100">
        {/* search inputs */}
        <div className="d-flex align-items-center" style={{ width: "70%" }}>
          <div className="w-50 mb-2">
            <FormControl fullWidth variant="outlined" size="small">
              <InputLabel htmlFor="search-orders">
                Search by order ID or customer name...
              </InputLabel>
              <OutlinedInput
                id="search-orders"
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                // onKeyUp={getOrders}
                label="Search by order ID or customer name..."
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton onClick={getOrders}>
                      <Search />
                    </IconButton>
                  </InputAdornment>
                }
              />
            </FormControl>
          </div>
          <div className="w-25 mb-2 mx-2">
            <DatePickerDMY
              value={filterDate}
              onChange={(iso) => {
                setFilterDate(iso);
                setPage(0);
              }}
            />
          </div>
        </div>
        {/* filter */}
        <div
          className="d-flex justify-content-end align-items-center"
          style={{ width: "30%" }}
        >
          {user?.operator.roles[0].name === "outbound-agent" ? (
            ""
          ) : (
            <button
              onClick={
                canViewAssigned
                  ? () => navigate("/Map")
                  : arrangedDone
                    ? () => navigate("/Map")
                    : handleAutoArrangeClick
              }
              disabled={isButtonDisabled}
              className="btn btn-outline-secondary d-flex align-items-center mb-2 mx-2"
            >
              {autoArrangeLoading ? (
                <>
                  <CircularProgress size={18} className="me-2" />
                  Arranging orders
                </>
              ) : canViewAssigned ? (
                <>
                  <Eye size={20} className="me-2" />
                  View Assigned Orders
                </>
              ) : arrangedDone ? (
                <>
                  <Eye size={20} className="me-2" />
                  View Arranged Orders
                </>
              ) : canAutoArrange ? (
                <>
                  <AutoMode className="me-2 small" />
                  Auto Arrange to Vehicles.
                </>
              ) : (
                <>
                  <AutoMode className="me-2 small" />
                  Auto Arrange to Vehicles.
                </>
              )}
            </button>
          )}
          <div className="position-relative filter-contianer mb-2">
            <IconButton
            //   onClick={() => setShowFilterDropdown((prev) => !prev)}
            >
              <FilterList />
            </IconButton>
            {/* {showFilterDropdown && (
                                  <div
                                    className="position-absolute mt-2 rounded shadow"
                                    style={{
                                      width: "240px",
                                      right: 0,
                                      backgroundColor: "#fff",
                                      border: "1px solid #ddd",
                                      padding: "16px",
                                      zIndex: 10,
                                    }}
                                  >
                                    <p className="fw-bold mb-2">Filter by Category</p>
                                    <div style={{ maxHeight: "200px", overflowY: "auto" }}>
                                      {categories.map((cat) => (
                                        <label
                                          key={cat}
                                          className="d-flex align-items-center mb-2"
                                          style={{
                                            cursor: "pointer",
                                            fontSize: "14px",
                                            gap: "8px",
                                          }}
                                        >
                                          <input
                                            type="checkbox"
                                            checked={selectedCategories.includes(cat)}
                                            onChange={(e) => {
                                              if (e.target.checked) {
                                                setSelectedCategories((prev) => [...prev, cat]);
                                              } else {
                                                setSelectedCategories((prev) =>
                                                  prev.filter((c) => c !== cat)
                                                );
                                              }
                                            }}
                                          />
                                          <span>{cat}</span>
                                        </label>
                                      ))}
                                    </div>
                                  </div>
                                )} */}
          </div>
        </div>
      </div>
      {/* tabs section */}
      <div
        className="tabs-section bg-light rounded-3 d-flex align-items-center mb-3"
        style={{
          width: "100%",
          flexWrap: "wrap",
        }}
      >
        <Tabs
          value={selectedTab}
          onChange={(_, newValue) => setSelectedTab(newValue)}
          variant="standard"
          aria-label="dynamic tabs"
          TabIndicatorProps={{ style: { display: "none" } }}
          sx={{
            width: "100%",
            "& .MuiTabs-flexContainer": {
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "12px",
              width: "100%",
            },
            "& .MuiTab-root": {
              textTransform: "none",
              borderRadius: "10px",
              minHeight: "40px",
              color: "#000",
              fontWeight: 500,
              transition: "all 0.3s ease",
            },
            "& .MuiTab-root.Mui-selected": {
              backgroundColor: "#000",
              color: "#fff",
            },
          }}
        >
          <Tab
            key="all"
            value="all"
            label={
              <span className="tab-label">
                All <span className="circle">{total}</span>
              </span>
            }
          />
          {statuses.map((st) => (
            <Tab
              key={st.id}
              value={st.name}
              label={
                <span className="tab-label">
                  {st.label}
                  <span
                    className="circle"
                    style={{ backgroundColor: st.color }}
                  >
                    {st.order_count}
                  </span>
                </span>
              }
            />
          ))}
        </Tabs>
      </div>
      {/* table data */}
      <>
        <TableContainer
          component={Paper}
          sx={{
            mt: 3,
            borderRadius: "12px",
            overflowX: "auto",
            overflowY: "hidden",
            boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
            border: "1px solid #e0e0e0",
            transition: "all 0.3s ease",
          }}
        >
          <Table
            size="small"
            sx={{
              minWidth: "900px",
              borderCollapse: "separate",
              borderSpacing: "0",
              "& td, & th": {
                textAlign: "center",
                verticalAlign: "middle",
                whiteSpace: "nowrap",
              },
              "& thead th": {
                backgroundColor: "#f8f9fa",
                fontWeight: 700,
                color: "#555",
                fontSize: "13px",
                borderBottom: "2px solid #e8e8e8",
                padding: "12px 7px",
                letterSpacing: "0.3px",
              },
              "& tbody tr": {
                transition: "background-color 0.2s ease",
              },
              "& tbody tr:hover": {
                backgroundColor: "#fafafa",
              },
              "& td": {
                fontSize: "13px",
                color: "#333",
                borderBottom: "1px solid #f0f0f0",
                padding: "12px 6px",
              },
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    color="primary"
                    indeterminate={
                      selectedRows.length > 0 &&
                      selectedRows.length < orders.length
                    }
                    checked={
                      orders.length > 0 && selectedRows.length === orders.length
                    }
                    onChange={handleSelectAll}
                    sx={{
                      padding: "6px",
                      color: "rgba(0,0,0,0.25)",
                      "&.Mui-checked, &.MuiCheckbox-indeterminate": {
                        color: "#3EADA3",
                      },
                      "& .MuiSvgIcon-root": {
                        fontSize: "22px",
                        fill: "transparent",
                        stroke: "rgba(0,0,0,0.25)",
                        strokeWidth: 1,
                      },
                      "&.Mui-checked .MuiSvgIcon-root, &.MuiCheckbox-indeterminate .MuiSvgIcon-root":
                        {
                          stroke: "#3EADA3",
                        },
                    }}
                  />
                </TableCell>
                <TableCell sx={{ minWidth: "200px", width: "200px" }}>
                  Reference
                </TableCell>
                <TableCell>Client Name</TableCell>
                <TableCell>Service</TableCell>
                <TableCell sx={{ minWidth: "150px", width: "150px" }}>
                  Preferred Time
                </TableCell>
                <TableCell>Status</TableCell>
                <TableCell>Assigned Van</TableCell>
                <TableCell>Actual Time</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {orders && orders.length > 0 ? (
                orders?.map((row) => {
                  const isSelected = selectedRows.includes(row.id);
                  const isOpen = openRowId === row.id;
                  const isNew = newOrderIds.has(row.id);
                  const isStatusUpdated = updatedStatusIds.has(row.id);
                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        hover
                        selected={isSelected}
                        sx={{
                          backgroundColor: isSelected
                            ? "#494646 !important"
                            : updatedStatusIds.has(row.id)
                              ? "inherit"
                              : isNew || row.is_read == "0"
                                ? "#D8F3EF !important"
                                : isOpen
                                  ? "#f9fafb"
                                  : "inherit",
                          "&:hover": {
                            backgroundColor: isSelected
                              ? "#413e3e !important"
                              : isStatusUpdated
                                ? `${row.order_status?.color}20 !important`
                                : isNew || row.is_read == "0"
                                  ? "#c5ece6 !important"
                                  : "#fafafa",
                          },
                          "& td": {
                            color: isSelected ? "#ffffff" : "#333",
                            fontWeight: isSelected ? 600 : 400,
                            transition: "all 0.2s ease",
                            backgroundColor: isSelected
                              ? "#494646 !important"
                              : updatedStatusIds.has(row.id)
                                ? "inherit"
                                : isNew || row.is_read == "0"
                                  ? "#D8F3EF !important"
                                  : "inherit",
                            borderBottom:
                              isNew || row.is_read == "0"
                                ? "1px solid #a8e0d8 !important"
                                : "1px solid #eee",
                          },
                          animation:
                            isNew || row.is_read == "0"
                              ? "slideInRow 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) forwards"
                              : "none",
                          position: "relative",
                          "&::after":
                            isNew || row.is_read == "0"
                              ? {
                                  content: '""',
                                  position: "absolute",
                                  left: 0,
                                  top: 0,
                                  height: "100%",
                                  width: "4px",
                                  background:
                                    "linear-gradient(180deg, #00897B, #4DB6AC)",
                                  borderRadius: "0 2px 2px 0",
                                }
                              : {},
                        }}
                      >
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isSelected}
                            onChange={() => handleSelectRow(row.id)}
                            sx={{
                              padding: "6px",
                              color: "rgba(0,0,0,0.25)",
                              "&.Mui-checked": {
                                color: "#3EADA3",
                              },
                              "& .MuiSvgIcon-root": {
                                fontSize: "22px",
                                fill: "transparent",
                                stroke: isSelected
                                  ? "#3EADA3"
                                  : "rgba(0,0,0,0.25)",
                                strokeWidth: 1,
                              },
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              gap: "4px",
                              width: "190px",
                            }}
                          >
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 600,
                                color: "#444",
                                backgroundColor: "#f0f0f0",
                                border: "1px solid #e0e0e0",
                                borderRadius: "6px",
                                padding: "2px 6px",
                                letterSpacing: "0.3px",
                                whiteSpace: "normal",
                                wordBreak: "break-all",
                                textAlign: "center",
                              }}
                            >
                              {row.reference || "-"}
                            </span>
                            {(isNew || row.is_read == "0") &&
                              !updatedStatusIds.has(row.id) && (
                                <span className="new-badge">NEW</span>
                              )}
                          </div>
                        </TableCell>
                        <TableCell sx={{ fontWeight: 500 }}>
                          {row.user?.name || "-"}
                        </TableCell>
                        <TableCell>
                          <div className=" d-flex justify-content-center align-items-center">
                            {row.categories?.map((cat) => (
                              <div style={{ width: "25px", height: "25px" }}>
                                <img
                                  src={
                                    cat.icon_url?.startsWith("http")
                                      ? cat.icon_url
                                      : `${newBaseUrl}${cat.icon_url}`
                                  }
                                  alt=""
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "contain",
                                  }}
                                />
                              </div>
                            ))}
                          </div>
                        </TableCell>
                        <TableCell>
                          {row.scheduled_date !== null ? (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px",
                                width: "150px",
                              }}
                            >
                              <div>{formatDate(row.scheduled_date)}</div>

                              <div
                                style={{
                                  fontSize: "12px",
                                  color: "#444",
                                  padding: "2px 6px",
                                  letterSpacing: "0.3px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-all",
                                  textAlign: "center",
                                }}
                              >
                                {row.scheduled_from} to {row.scheduled_to}
                              </div>
                            </div>
                          ) : (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                gap: "4px",
                                width: "150px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "13px",
                                  color: "#444",
                                  padding: "2px 6px",
                                  letterSpacing: "0.3px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-all",
                                  textAlign: "center",
                                }}
                              >
                                {row.reservation?.full_schedule}
                              </span>
                            </div>
                          )}
                        </TableCell>
                        <TableCell>
                          {(() => {
                            const isUpdated = updatedStatusIds.has(row.id);
                            const transition = statusTransitions[row.id];
                            return (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "5px",
                                  padding: "4px 8px",
                                  borderRadius: "10px",
                                  backgroundColor: isUpdated
                                    ? "rgba(62,173,163,0.07)"
                                    : "transparent",
                                  animation: isUpdated
                                    ? "statusCellPulse 0.8s ease both"
                                    : "none",
                                }}
                              >
                                {/* was: القديمة */}
                                {isUpdated && transition && (
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "4px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "9px",
                                        color: "#bbb",
                                        fontWeight: 600,
                                        letterSpacing: "0.5px",
                                        textTransform: "uppercase",
                                      }}
                                    >
                                      was
                                    </span>
                                    <div
                                      style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "4px",
                                        backgroundColor: "#f5f5f5",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: "20px",
                                        padding: "2px 8px",
                                      }}
                                    >
                                      {transition.oldIcon && (
                                        <img
                                          src={transition.oldIcon}
                                          alt=""
                                          style={{
                                            width: "11px",
                                            height: "11px",
                                            objectFit: "contain",
                                            filter: "grayscale(1)",
                                            opacity: 0.45,
                                          }}
                                        />
                                      )}
                                      <span
                                        style={{
                                          fontSize: "10px",
                                          fontWeight: 600,
                                          color: "#bbb",
                                          whiteSpace: "nowrap",
                                          textDecoration: "line-through",
                                        }}
                                      >
                                        {transition.oldName}
                                      </span>
                                    </div>
                                  </div>
                                )}

                                {/* الجديدة — badge */}
                                <div
                                  style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    gap: "6px",
                                    backgroundColor: isUpdated
                                      ? "rgba(62,173,163,0.13)"
                                      : "#f5f5f5",
                                    border: `1.5px solid ${isUpdated ? "#3EADA3" : "#e0e0e0"}`,
                                    borderRadius: "20px",
                                    padding: "4px 10px",
                                    transition:
                                      "background-color 0.4s ease, border-color 0.4s ease",
                                    animation: isUpdated
                                      ? "statusNewPop 0.5s ease both, statusGlowPulse 0.8s ease 0.3s both"
                                      : "none",
                                  }}
                                >
                                  <img
                                    src={row.order_status?.image_url}
                                    alt=""
                                    style={{
                                      width: "14px",
                                      height: "14px",
                                      objectFit: "contain",
                                      animation: isUpdated
                                        ? "statusIconBounce 0.5s ease 0.15s both"
                                        : "none",
                                    }}
                                  />
                                  <span
                                    style={{
                                      fontWeight: 600,
                                      fontSize: "11px",
                                      color: isUpdated ? "#3EADA3" : "#444",
                                      whiteSpace: "nowrap",
                                      transition: "color 0.3s ease",
                                    }}
                                  >
                                    {row.order_status?.label}
                                  </span>
                                </div>
                              </div>
                            );
                          })()}
                        </TableCell>
                        <TableCell>
                          {row.vehicle_assignment?.vehicle?.model?.name || "-"}
                        </TableCell>
                        <TableCell>
                          {row.estimated_duration_minutes} mins
                        </TableCell>
                        <TableCell>
                          <div className="d-flex justify-content-center align-items-center w-25 mx-auto">
                            {user?.operator.roles[0].name === "agent" ? (
                              ""
                            ) : (
                              <>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    saveLastKnownStatus(row);
                                    clearNewOrder(row.id);
                                    clearUpdatedStatus(row.id);
                                    if (row.is_read == "0")
                                      handleToggleRead(row.id);
                                    navigate(`/Activity/${row.id}`);
                                  }}
                                >
                                  <Add fontSize="small" />
                                </IconButton>
                                <IconButton
                                  size="small"
                                  onClick={() => {
                                    saveLastKnownStatus(row);
                                    clearNewOrder(row.id);
                                    clearUpdatedStatus(row.id);
                                    if (row.is_read == "0")
                                      handleToggleRead(row.id);
                                    navigate(`/orders/${row.id}`);
                                  }}
                                >
                                  <PenSquare size={18} />
                                </IconButton>
                              </>
                            )}
                            {row.is_read == "1" && (
                              <IconButton
                                size="small"
                                onClick={() => handleToggleRead(row.id)}
                                title="Mark as unread"
                              >
                                <EyeOff size={18} />
                              </IconButton>
                            )}
                            <IconButton
                              size="small"
                              onClick={() => {
                                clearNewOrder(row.id);
                                clearUpdatedStatus(row.id);
                                if (row.is_read == "0")
                                  handleToggleRead(row.id);
                                handleToggleRow(row.id);
                              }}
                            >
                              {isOpen ? <ChevronUp /> : <ChevronDown />}
                            </IconButton>
                          </div>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell
                          style={{
                            padding: 0,
                            borderTop: "none",
                          }}
                          colSpan={9}
                        >
                          <Collapse in={isOpen} timeout="auto" unmountOnExit>
                            <Box
                              sx={{
                                padding: "20px 32px",
                                backgroundColor: "#fafbfc",
                                borderTop: "1px solid #eeeeee",
                                borderBottom: "1px solid #eeeeee",
                              }}
                            >
                              {/* Row 1 */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(5, 1fr)",
                                  gap: "0",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  border: "1px solid #ebebeb",
                                  backgroundColor: "#fff",
                                  marginBottom: "1px",
                                }}
                              >
                                {[
                                  { label: "Order ID", value: `#${row.id}` },
                                  {
                                    label: "Mobile",
                                    value: row.user?.phone_number || "-",
                                    mono: true,
                                  },
                                  {
                                    label: "Location",
                                    value: row.address?.area || "-",
                                  },
                                  {
                                    label: "Email",
                                    value: row.user?.email || "-",
                                  },
                                  {
                                    label: "Order Date",
                                    value: new Date(
                                      row.created_at,
                                    ).toLocaleDateString(),
                                  },
                                ].map((item, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      padding: "14px 16px",
                                      borderRight:
                                        i < 4 ? "1px solid #ebebeb" : "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#999",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#333",
                                        fontFamily: item.mono
                                          ? "monospace"
                                          : "inherit",
                                        direction: item.mono
                                          ? "ltr"
                                          : "inherit",
                                      }}
                                    >
                                      {item.value}
                                    </span>
                                  </div>
                                ))}
                              </div>

                              {/* Row 2 */}
                              <div
                                style={{
                                  display: "grid",
                                  gridTemplateColumns: "repeat(3, 1fr)",
                                  gap: "0",
                                  borderRadius: "10px",
                                  overflow: "hidden",
                                  border: "1px solid #ebebeb",
                                  backgroundColor: "#fff",
                                  marginTop: "8px",
                                }}
                              >
                                {[
                                  {
                                    label: "Price",
                                    value: formatNumber(row.total),
                                  },
                                  {
                                    label: "Agent Name",
                                    value: row.agent?.name || "-",
                                  },
                                  {
                                    label: "Car Model",
                                    value: row.vehicle?.name || "-",
                                  },
                                ].map((item, i) => (
                                  <div
                                    key={i}
                                    style={{
                                      padding: "14px 16px",
                                      borderRight:
                                        i < 2 ? "1px solid #ebebeb" : "none",
                                      display: "flex",
                                      flexDirection: "column",
                                      gap: "5px",
                                    }}
                                  >
                                    <span
                                      style={{
                                        fontSize: "11px",
                                        fontWeight: 600,
                                        color: "#999",
                                        textTransform: "uppercase",
                                        letterSpacing: "0.5px",
                                      }}
                                    >
                                      {item.label}
                                    </span>
                                    <span
                                      style={{
                                        fontSize: "13px",
                                        fontWeight: 600,
                                        color: "#333",
                                      }}
                                    >
                                      {item.value}
                                    </span>
                                  </div>
                                ))}
                              </div>
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={9} sx={{ height: "300px", p: 0 }}>
                    <Box
                      sx={{
                        height: "100%",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                      }}
                    >
                      <NotFound
                        paragraphText={
                          "No orders yet. All your orders will appear here once you get started."
                        }
                      />
                    </Box>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          count={totalCount}
          page={page}
          onPageChange={handleChangePage}
          rowsPerPage={rowsPerPage}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
          rowsPerPageOptions={[5, 10, 20]}
          sx={{
            ".MuiTablePagination-toolbar": { justifyContent: "center" },
          }}
        />
      </>
    </div>
  );
}
